/**
 * Tallies per-claim Approve / Reject / Correct decisions.
 * Undecided (or unknown) decisions count as `flagged` — used by Gov Promotion
 * when attestation is allowed before every row is decided.
 *
 * @param {Array<{ id: string }>} claims
 * @param {Record<string, string | undefined>} decisions
 * @param {{ approveKey?: 'approved' | 'promoted' }} [options]
 */
export function tallyClaimDecisions(claims, decisions, { approveKey = 'approved' } = {}) {
  return claims.reduce(
    (counts, claim) => {
      const decision = decisions[claim.id];
      if (decision === 'approve') counts[approveKey] += 1;
      else if (decision === 'reject') counts.rejected += 1;
      else if (decision === 'correct') counts.corrected += 1;
      else counts.flagged += 1;
      return counts;
    },
    { [approveKey]: 0, rejected: 0, corrected: 0, flagged: 0 },
  );
}
